/* LP founder hero — smooth-scroll the hero CTA to the target section (default: the product grid). */
(function () {
  function bind(btn) {
    if (btn.dataset.lpfhBound) return;
    btn.dataset.lpfhBound = '1';
    btn.addEventListener('click', function () {
      var sel = btn.getAttribute('data-lpfh-scroll');
      var target = sel && document.querySelector(sel);
      if (!target) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-lpfh-scroll]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
